module.exports = __webpack_public_path__ + "static/img/14.d57c14d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/14.png
// module id = q1cw
// module chunks = 0